<template>
  <v-container>

    <entity-properties-row :label="$t('corporationSettings.logo')">
      <img
          v-if="this.$store.getters['corporationSettingsState/logoUrl']"
          class="corporation-settings-dialog-selected-image"
          v-bind:src="this.$store.getters['corporationSettingsState/logoUrl']"
          alt="Logo">
    </entity-properties-row>

    <entity-properties-row :label="$t('corporationSettings.background')">
      <img
          v-if="this.$store.getters['corporationSettingsState/backgroundImageUrl']"
          class="corporation-settings-dialog-selected-image"
          v-bind:src="this.$store.getters['corporationSettingsState/backgroundImageUrl']"
          alt="Background">
    </entity-properties-row>

    <entity-properties-row >
      <v-btn tile
             color="primary"
             @click="$refs.settingsDialog.open()">
        {{ this.$t('actions.modify') }}
        <v-icon right dark>
          mdi-border-color
        </v-icon>
      </v-btn>
    </entity-properties-row>

    <corporation-settings-dialog ref="settingsDialog"/>
  </v-container>
</template>

<script>
import Vue from 'vue';
import CorporationSettingsService from '@/services/CorporationSettingsService';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import CorporationSettingsDialog from '@/views/corporation-settings/CorporationSettingsDialog';

export default Vue.extend({
  components: { CorporationSettingsDialog, EntityPropertiesRow },
  name: 'CorporationSettings',
  data() {
    return {
      servedMediaAssetsUrl: CorporationSettingsService.getServedMediaAssetsUrl(),
      corporationSettings: null,
    };
  },
  created() {
    this.$store.dispatch('corporationSettingsState/update');
  },
});
</script>
